import React from 'react'
import { CardContent } from 'semantic-ui-react'
import Active from './Active'
import Past from './Past'
import Pending from './Pending'
import Transactions from './Transactions'

const CardFooter = ({ status, project, job }) => {
  const renderInfo = () => {
    switch (status) {
      case 'active':
        return <Active project={project} job={job} />
      case 'pending':
        return <Pending project={project} job={job} />
      case 'past':
        return <Past project={project} job={job} />
      default:
        return <div />
    }
  }

  return (
    <CardContent extra>
      {renderInfo()}
      <div id="job-transactions">
        <Transactions job={job} />
      </div>
    </CardContent>
  )
}

export default CardFooter
